// TaskTimer.js - Small Task Encouragement Timer
import React, { useState, useEffect } from 'react';

const TaskTimer = () => {
    const [time, setTime] = useState(300); // default 5 minutes
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let timer;
        if (isRunning && time > 0) {
            timer = setInterval(() => setTime(time - 1), 1000);
        } else if (time === 0) {
            clearInterval(timer);
            alert('Great job! You made progress! 🎉');
            setIsRunning(false);
            setTime(300); // Reset timer after completion
        }
        return () => clearInterval(timer);
    }, [isRunning, time]);

    return (
        <div className="p-4 bg-gray-50 rounded shadow-sm my-2 mx-4 text-center">
            <h2 className="font-semibold text-indigo-700">Quick Task Timer ⏲️</h2>
            <div className="text-3xl my-2 font-mono">
                {Math.floor(time / 60).toString().padStart(2, '0')}:
                {(time % 60).toString().padStart(2, '0')}
            </div>
            <button
                className="bg-indigo-500 text-white px-4 py-2 rounded-full"
                onClick={() => setIsRunning(!isRunning)}
            >
                {isRunning ? 'Pause' : 'Start'}
            </button>
            <p className="mt-2 text-sm text-gray-600 italic">
                “Anything worth doing is worth doing poorly.” – G.K. Chesterton
            </p>
            <p className="text-sm text-gray-600">
                You made it! Great job!
            </p>
        </div>
    );
};

export default TaskTimer;
